<template>
  <div class="toggle-preload preload-active">
    <img src="@/assets/img/static/rolling.gif" alt="">
  </div>
</template>

<script>
  export default {
    name: "Loading"
  }
</script>

<style scoped>

</style>
